import {useEffect} from 'react'
import {NewForm, useForm} from '@eitje/form'
import utils from '@eitje/utils'
import {bridge} from '@eitje/bridge'
import {EitjeModal} from '../../modal'
import {useModalContext} from '../../modal_context'
import {NewFormModalSubmitButton} from './buttons'

const {useLocation} = bridge

const Inner = ({modalProps = {}}) => {
	const {okButtonProps = {}, watch, ...rest} = modalProps
	const {setModalPropsRaw} = useModalContext()
	const {submit, getData, form} = useForm()
	const loc = useLocation()

	useEffect(() => {
		setModalPropsRaw({
			form: true,
			FooterSubmitButton: NewFormModalSubmitButton,
			okButtonProps: {...okButtonProps, form, submit, getData},
			...rest,
		})
	}, [loc.pathname, JSON.stringify(okButtonProps), watch])

	return null
}

export const ModalWithNewForm = ({name, width, className, modalProps, ...props}) => {
	const classNames = utils.makeCns('eitje-form-3-modal', className)
	return (
		<EitjeModal name={name} width={width} className={classNames} {...modalProps} form>
			<NewModalForm {...props} modalProps={modalProps} />
		</EitjeModal>
	)
}

export const NewModalForm = ({children, modalProps, ...props}) => {
	const {names} = useModalContext()

	return (
		<NewForm name={names} {...props}>
			<Inner modalProps={modalProps} />
			{children}
		</NewForm>
	)
}
